import React, { useState, useEffect, useContext } from "react";
import { Badge, Container, Button } from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";
import MyLanding from "./InternalPages/Mylanding";

const Blog = () => {
  useEffect(() => {
    const currentUrl = window.location.href; 
    const encodedUrl = encodeURIComponent(currentUrl);
  
    const script = document.createElement("script");
    script.src = `https://packky.com/SeoBix/seo_injection.php?webid=cd8435ad15b4e27805d9e08fbaa8d536&url=${encodedUrl}&baseUrl=https%3A%2F%2Fpackky.com`;
    script.async = true;
  
    document.body.appendChild(script);
  
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  
  useEffect(() => {
    window.scrollTo(0, 0);
    const script = document.createElement("script");
    script.type = "module";
    script.src = "/off_seo.js";
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <Container fluid className="p-0" style={{ overflowX: "hidden" }}>
        {/* home */}

        <div>
          <Nav />
        </div>
        <div className="container pt-5 mt-5">
          <div className="mt-md-4">
            <div className="row  mx-md-0 mx-3 ">
              <div className="col-md-1 "></div>
              <div className="col-md-10 col-12 m-0 p-0">
                <div
                  className="row "
                  style={{ overflow: "hidden", height: "auto" }}
                >
                  <div className=" col-12 m-0 p-0 ">
                    <div className="" style={{ marginRight: "" }}>
                      <MyLanding />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-1"></div>
            </div>
          </div>
        </div>

        <div
          className="m-0 p-0"
          style={{
            overflow: "hidden",
            background: "#31393C",
            borderTopRightRadius: "2rem",
            borderTopLeftRadius: "2rem",
          }}
        ></div>
      </Container>
    </>
  );
};

export default Blog;
